<template>
    <v-container>
        <v-card-text v-if="content" v-html="content"/>
        <v-card-text v-else>Нет данных</v-card-text>
    </v-container>
</template>

<script>
    import BonusService from '@/services/bonus.service'

    export default {
        name: 'BonusScreen',

        data: () => ({
            content: undefined,
        }),

        mounted() {
            this.bootstrap()
        },

        methods: {
            async bootstrap() {
                try {
                    const response = await BonusService.getBonusPageContent()

                    this.content = response?.content
                } catch (error) {
                    await this.$root.pushNotification({
                        text: error.message,
                        color: 'error',
                    })
                }
            },
        },
    }
</script>
